import { SxProps, Theme } from '@mui/material/styles';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

type NoArg = SxProps<Theme>;
type BooleanArg = (value: boolean) => SxProps<Theme>;
interface deliveryMethodSelectorInterface {
	container: NoArg;
	selectors: NoArg;
	option: NoArg;
	optionHeader: NoArg;
	blockIcon: NoArg;
	icon: BooleanArg;
	smallIcon: BooleanArg;
	spacing: NoArg;
	stockAlignBottom: NoArg;
	unavailableMessage: NoArg;
	restrictedMessage: NoArg;
	restrictedMessageLink: NoArg;
	footer: NoArg;
	footerRow: NoArg;
	footerLink: NoArg;
	footerSeparator: NoArg;
	footerCostFree: NoArg;
	footerLegal: NoArg;
	footerNoDateMessage: NoArg;
	skeletonOption: NoArg;
}

export const deliveryMethodSelectorSX: deliveryMethodSelectorInterface = {
	container: {
		padding: { md: '10px', lg: '20px' },
	},
	selectors: {
		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		gap: 1.25,
	},
	option: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		padding: 1.25,
		border: '1px solid',
		borderColor: 'grey.100',
		borderRadius: '3px',
		cursor: 'pointer',
		maxWidth: { xs: 'auto', md: '200px' },
		'&.delivery-selector__option--selected': {
			borderColor: 'grey.500',
			borderWidth: '2px',
		},
		'&.delivery-selector__option--disabled': {
			cursor: 'default',
			borderColor: 'grey.100',
			backgroundColor: 'grey.50',
			color: 'grey.200',
		},
	},
	optionHeader: {
		display: 'flex',
		marginTop: '5px',
	},
	blockIcon: {
		color: 'grey.300',
	},
	icon: (disabled: boolean) => ({
		color: disabled ? 'grey.200' : 'grey.500',
		height: '24px',
		width: '24px',
	}),
	smallIcon: (disabled: boolean) => ({
		color: disabled ? 'grey.200' : 'grey.500',
		height: '18px',
		width: '18px',
	}),
	spacing: {
		marginTop: '5px',
	},
	stockAlignBottom: {
		marginTop: 'auto',
	},
	footer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		marginTop: 1.25,
	},
	footerRow: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'center',
		gap: 0.5,
	},
	footerLink: {
		color: 'secondary.main',
		typography: 'bodyBaseline',
	},
	footerSeparator: {
		color: 'grey.50',
		typography: 'bodySubText',
	},
	footerCostFree: {
		color: 'success.main',
		typography: 'bodyBaseline',
		fontWeight: OpenSansFontWeights.semibold,
	},
	footerLegal: {
		color: 'grey.300',
	},
	footerNoDateMessage: {
		color: 'grey.300',
		typography: 'bodySubText',
	},
	restrictedMessage: {
		marginTop: 1.25,
		padding: 1.25,
		border: '1px solid',
		borderColor: 'grey.300',
		borderRadius: '3px',
	},
	restrictedMessageLink: {
		color: 'secondary.main',
		cursor: 'pointer',
		'&:hover': {
			textDecoration: 'underline',
		},
	},
	skeletonOption: {
		width: '45%',
		height: '100px',
		mx: '10px',
	},
	unavailableMessage: null,
};
